import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { catchNotFoundResolver } from '@commons/rxjs-operators/catch-error';
import { SearchMissionCivicService } from '@models/civic-service/mission-civic-service';
import { EventWebservice } from '@webservices/event-api/event.webservice';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class CivicServiceMissionResolver implements Resolve<SearchMissionCivicService> {
  constructor(
    private readonly eventWebservice: EventWebservice,
    private readonly router: Router,
    private readonly location: Location
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<SearchMissionCivicService> {
    return this.eventWebservice.getCivicServiceMission(route.paramMap?.get('missionId') ?? '').pipe(
      map((data) => {
        return {
          ...data,
          description: (data.description ?? '').replace(/\\n|\n/g, '<br>'),
          organization: {
            ...data.organization,
            description: (data.organization?.description ?? '').replace(/\\n|\n/g, '<br>'),
          },
        } as SearchMissionCivicService;
      }),
      catchNotFoundResolver(this.router, this.location, state.url)
    );
  }
}
